<script lang="ts" setup>
import { DropdownItem, Icon } from '@brighterly/lib-lumee-ui'

import { useContactLaunchers } from '@hooks/support/contact-launchers.hook'

import amplitudeConfig from '@config/amplitude.json'
import { getContacts } from '@config/support'

import { trackEvent } from '@tools/amplitude'

defineOptions({
  name: 'LinkSendSms',
})

const text = 'Send SMS'
const contacts = getContacts()

const {
  openSms,
} = useContactLaunchers()

const setSubmit = (): void => {
  const options = {
    phone: contacts.phone,
    body: 'Support request',
  }

  trackEvent(amplitudeConfig.events.clickLink, {
    name: 'link_send_sms',
    link_text: text,
    ...options,
  })
  openSms(options)
}

</script>

<template>
  <DropdownItem
    :title="text"
    role="menuitem"
    :aria-selected="undefined"
    @click="setSubmit"
  >
    <template #leading>
      <Icon
        name="comment"
        size="md"
        color="default"
      />
    </template>
  </DropdownItem>
</template>
